import { Component, computed, input, output } from "@angular/core";
import { EvDropdownComponent, OptionsObject } from "src/app/shared-components/ev-dropdown/ev-dropdown.component";
import { IProjectStageEstateType } from "src/app/infopage/new-dwelling/newdwelling.model";
import { EvKeyValuePairModule } from "ev-key-value-pair";

@Component({
    selector: "project-stage-selector",
    templateUrl: "./project-stage-selector.component.html",
    styleUrl: "./project-stage-selector.component.scss",
    imports: [EvDropdownComponent, EvKeyValuePairModule],
})
export class ProjectStageSelectorComponent {
    projectName = input<string>();
    projectStages = input<IProjectStageEstateType[]>();
    setSelectedStage = input<number>();
    selectedStage = output<OptionsObject>();

    dropdownOptions = computed(() => this.mapToDropdownOptions(this.projectStages()));

    onSelect(event: OptionsObject): void {
        this.selectedStage.emit(event);
    }

    private mapToDropdownOptions(stages: IProjectStageEstateType[]): OptionsObject[] {
        if (stages == null) {
            return [];
        }

        let options = [
            {
                key: -1,
                displayValue: "Prosjektoversikt",
                iconClass: this.projectIconClass(stages),
                data: { projectId: stages[0]?.projectId },
            },
        ];
        
        let mappedOptions = stages?.map((stage) => ({
            key: stage.projectStageEstateTypeId,
            displayValue: `${stage.stageName}, ${stage.estateTypeDescription}`,
            counter: stage.numUnits,
            iconClass: this.stageIconClass(stage),
            data: stage,
        }));

        return [...options, ...mappedOptions];
    }

    private projectIconClass(stages: IProjectStageEstateType[]): string | undefined {
        if (stages.length === 0) {
            return undefined;
        }

        const first = stages[0];
        const mixed = stages.some((stage) => stage.estateType !== first.estateType);
        return mixed ? "property-borettslag" : this.stageIconClass(first);
    }

    private stageIconClass(stage: IProjectStageEstateType): string | undefined {
        return stage?.estateTypeCssString ? `property-${stage.estateTypeCssString}` : undefined;
    }
}
